/**
 * Context menu for listing storables.
 */
import * as ArchiveActions from 'archive/ArchiveActions';
import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import isArchived from 'archive/isArchived';
import {Permissions} from 'auth/PermissionConstants';
import * as contextmenu from 'components/ContextMenu';
import {ContextMenuOption} from 'components/ContextMenu';
import {StorableSummary} from 'constants/SampleConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import PrintBarcodeModal from 'label-printing/PrintBarcodeModal';
import preferences from 'Preferences';
import legacyRunModal from 'ui-library/legacyRunModal';
import copyToClipboard from 'util/clipboard/copyToClipboard';
import {dispatchRemoveWorklistItems} from 'worklists/WorklistActions';

export interface StorableWithWorklistId extends StorableSummary {
  worklistId?: string;
  permissions?: Permissions;
}

// Export function for testing.
export function _getContextMenuOptions(storable: StorableWithWorklistId): Array<ContextMenuOption> {
  return [
    {
      name: 'Open',
      click() {
        FileBrowserActions.openFile(storable.id);
      },
      dataTestAttrs: {component: 'StorableContextMenu', element: 'open'},
    },
    '-',
    {
      name: 'Remove from worklist',
      click() {
        dispatchRemoveWorklistItems(storable.worklistId!, [storable.id], {
          refreshWorklistItemsSearch: true,
          refreshRecentWorklists: true,
        });
      },
      hide() {
        return !storable.worklistId;
      },
    },
    '-',
    {
      name: 'Archive',
      click() {
        ArchiveModal.open({items: [storable], onArchive: ArchiveActions.bulkArchiveStorablesWithDataMods});
      },
      disabled() {
        return !storable.permissions?.archivable;
      },
      hide() {
        return isArchived(storable);
      },
    },
    {
      name: 'Unarchive',
      click() {
        ArchiveActions.bulkUnarchiveStorablesWithDataMods([storable.id]);
      },
      disabled() {
        return !storable.permissions?.unarchivable;
      },
      hide() {
        return !isArchived(storable);
      },
    },
    {
      name: 'Print',
      click() {
        legacyRunModal(PrintBarcodeModal, {itemIds: [storable.id]});
      },
    },
    '-',
    {
      name: 'Copy API ID',
      click() {
        copyToClipboard(storable.id, {showToastOnSuccess: true});
      },
      hide() {
        return !preferences.get('ENABLE_COPY_API_ID');
      },
    },
  ];
}

export function open(e: Event, storable: StorableWithWorklistId): void {
  contextmenu.view.open(e, _getContextMenuOptions(storable));
}
